import Vue from 'vue'
import axios from 'axios'
import * as _ from 'lodash';

export default {
    namespaced: true,
    state: {
        users: [],
    },
    mutations: {
        fetchUsers(state, payload) {
            // add full_name
            for (let i = 0; i < payload.length; i++ ) {
                payload[i].full_name = (payload[i].first_name  + ' ' + payload[i].last_name).trim();
            }

            // default order by name
            state.users = _.orderBy(payload, user => user.full_name);
        },
        setUsers(state, payload) {
            state.users = payload;
        },
        addUsersToList(state, payload) {
            // fix to prevent double insert(from http and Socket.io), check is user already inserted (by this application instance)
            let user = _.find(state.users, p => p.id == payload.id);
            if (user) {
                return; // exit
                //? or pass to update
            }

            payload.full_name = (payload.first_name  + ' ' + payload.last_name).trim();
            (state.users).push(payload);
        },
        editUser(state, payload) {
            payload.full_name = (payload.first_name  + ' ' + payload.last_name).trim();
            const index = state.users.findIndex(item => item.id === payload.id);
            Vue.set(state.users, index, payload);
        },
        deleteUser(state, payload) {
            state.users.map((user,index) => {
                if (user.id == payload.id) {
                    state.users.splice(index,1);
                }
            })
        },
    },

    actions: {
        async fetchUsers({ commit, dispatch }) {
            commit('clearError', null, { root: true })
            commit('setLoading', true, { root: true });

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/user`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false, { root: true });
                commit('fetchUsers', data);
            } catch(error) {
                commit('setLoading', false, { root: true });

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser', null, { root: true });
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0], { root: true });
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message, { root: true });
                } else {
                    dispatch('setError', error, { root: true });
                }
            }
        },
        async createNewUser({commit, dispatch}, {payload}) {
            commit('clearError', null, { root: true })
            commit('setLoading', true, { root: true })

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/user`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false, { root: true });
                commit('addUsersToList', data)
                return data;
            } catch(error) {
                commit('setLoading', false, { root: true });

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser', null, { root: true });
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0], { root: true });
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message, { root: true });
                } else {
                    dispatch('setError', error, { root: true });
                }

                throw error;
            }
        },

        async editUser({commit, dispatch}, payload) {
            commit('clearError', null, { root: true })
            commit('setLoading', true, { root: true })

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/user/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    },
                    params: {
                        'inactive': 'false'
                    }
                });

                commit('setLoading', false, { root: true });
                commit('editUser', data);
            } catch(error) {
                commit('setLoading', false, { root: true });

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser', null, { root: true });
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0], { root: true });
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message, { root: true });
                } else {
                    dispatch('setError', error, { root: true });
                }

                throw error;
            }
        },

        async deleteUser({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.delete(`${this._vm.appConfig.app_url}/api/user/${payload.id}`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('deleteUser', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }

                throw error
            }
        },

    },

    getters: {
        users(state) {
            return state.users
        },
    }
}